import React, {useState, useRef, useEffect} from "react";
import brands1 from '../assets/images/brands1.jpg';
import {Link} from "react-router-dom";
import logo from '../assets/images/logo.svg';
import Footer from "./Footer";
import TopNav from "./TopNav";
import sia, {WEB_URL} from "../services/Api";
import LoaderView from "../tools/LoaderView";

import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'

const KhatmQoran = (props) => {

    const [selectedSoundIndex, setSelectedSoundIndex] = useState(0)
    const [isLoading, setLoading] = useState(true)
    const [responseData, setResponseData] = useState()
    const [isLoadingShomaresh, setLoadingShomaresh] = useState(false);
    const [minShomaresh, setMinShomaresh] = useState(1);
    const khatmId = useRef()

    useEffect(() => {
        const search = props.location.search
        const params = new URLSearchParams(search)
        khatmId.current = params.get('id')

        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        await sia.getDataFromServer('funeral/' + khatmId.current).then((res) => {
            if (res.status == 200) {
                const data = res.data
                data.shomarsh?.map((item) => {
                    data.prays?.forEach((pray) => {
                        if (pray._id == item.pray_id) {
                            pray.count = item.count
                        }
                    })
                })
                setResponseData(data)
                if(data.shomarsh) {
                    data.shomarsh.map((item) => {
                        if (item.count <= minShomaresh) {
                            setMinShomaresh(item.count)
                        }
                    })
                }
                else {
                    setMinShomaresh(0)
                }
            }
        }).catch((err) => console.error(err))
        setLoading(false)
    }

    const read = async (prayId, index) => {
        setLoadingShomaresh(true)
        const postBody = {
            pray_id: prayId,
        }
        await sia
            .PostDataToServer("/addToShomarsh/" + khatmId.current, postBody)
            .then((res) => {
                if (res.status == 200) {
                    if (responseData.prays[index].count) {
                        responseData.prays[index].count += 1
                    } else {
                        responseData.prays[index].count = 1
                        responseData.shomarsh.push({pray_id: prayId, count: 1})
                    }
                    setResponseData(responseData)
                    notifySuccessful()
                }
            })
            .catch((err) => console.log(err));
        setLoadingShomaresh(false)
    };

    return (
        <>
            <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
            <header>
                <div className="pagewrapper slim2" id="header-slim">
                    <div className="container">
                        <TopNav/>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            {isLoading ? <LoaderView/> : <div>
                <div className="pagewrapper">
                    <div className="container">
                        <h1 id="khatm-single-main-title">ختم {function () {
                            switch (responseData.type) {
                                case "1":
                                    return 'قرآن'
                                case "2":
                                    return 'ادعیه'
                                case "3":
                                    return 'صلوات'
                                case "4":
                                    return 'جزء'
                                case "5":
                                    return 'سوره'
                                default:
                                    return responseData.type
                            }
                        }()}</h1>
                    </div>
                </div>
                <div className="pagewrapper" id="statistics">
                    <div className="container">
                        <div className="left-col">
                            <div className="stat-item box-sizing">
                                <span>{responseData.repeat}</span>
                                تعداد کل
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{minShomaresh}
                                    </span>
                                خوانده شده
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{responseData.repeat - (responseData.shomarsh && responseData.shomarsh.length > 0 ? responseData.shomarsh[0].count : 0)}</span>
                                مانده
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagewrapper" id="khatm-hajat">
                    <div className="container">
                        <h2 className="hajat-title">حاجت از ختم</h2>
                        <p className="hajat-text box-sizing radius10">
                            {responseData.wish}
                        </p>
                    </div>
                </div>
                <div className="pagewrapper" id="khatm-ghoran-player">
                    <div className="container">
                        <h2 className="main-title">موارد ختم</h2>
                        <ul className="khatm-player-list">
                            {responseData.prays.map((item, prayIndex) => <li
                                className="clickable item box-sizing radius10">
                                <h3 className="title">{item.name}<span
                                    className="stat">(خوانده شده: {item.count ?? 0})</span></h3>
                                <audio controls>
                                    <source src={WEB_URL + item.sounds[selectedSoundIndex].sound} type="audio/mp3"/>
                                    Your browser does not support the audio element.
                                </audio>
                                <a title onClick={() => read(item._id, prayIndex)}
                                   className="btn radius10 ease box-sizing mouse-cursor-pointer">تقبل قرائت</a>
                                <select name="ghaari" onChange={(e) => {
                                    setSelectedSoundIndex(e.target.value)
                                }} className="select blue radius10 box-sizing ease">
                                    <option value={-1}>انتخاب قاری</option>
                                    {item.sounds.map((sound, index) => <option value={index}>{sound.nameGhari}</option>
                                    )}
                                </select>
                            </li>)}
                        </ul>
                        <div className="clear"/>
                    </div>
                </div>
            </div>}
            <div className="clear"/>
            <Footer/>
        </>
    );
}

export default KhatmQoran;
